import axios from "axios";

export function getUnprocessPrifeClaimNotification() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/consumer/admin/api/v1/prife/claims/notification-count`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
